module.exports = __webpack_public_path__ + "img/invite-reward-icon.de4a5b61.png";